import styled from '@emotion/styled';
import { Box } from '@mui/material';
import {
  BASIC_BORDER_RADIUS,
  BASIC_BORDER_COLOR,
  BASE_FIELD_BACKGROUND_COLOR,
} from '../../themes/tokens';

export const SdpDashboardWrapper = styled(Box)`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => (theme as any).spacing(2)};
  border-radius: ${BASIC_BORDER_RADIUS};
  border: 1px solid ${BASIC_BORDER_COLOR};
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
  backdrop-filter: blur(7px);
`;
